export interface Article {
  id: string;
  title: string;
  slug: string;
  categorySlug: string;
  categoryName: string;
  excerpt: string;
  content: string;
  coverImage: string;
  author: string;
  publishDate: string;
  views: number;
  likes: number;
  tags: string[];
  isFeatured: boolean;
}

export const articles: Article[] = [
  {
    id: 'article-1',
    title: '萌白酱2026夏日限定cosplay特辑——海边度假篇',
    slug: 'summer-cosplay-2026',
    categorySlug: 'cosplay',
    categoryName: 'Cosplay写真',
    excerpt: '这个夏天，萌白酱带来了全新海边度假主题cosplay写真，清新海风搭配甜美造型，带你感受夏日的浪漫与活力。',
    content: `<p>盛夏时节，萌白酱为大家带来了精心筹备的海边度假主题cosplay写真特辑。这次拍摄选址在三亚一处隐秘的私人海滩，蓝天白云、碧海金沙构成了最完美的天然背景。</p>
    <p>本次写真中，萌白酱一共呈现了三套不同风格的造型：</p>
    <h3>1. 清新水手服</h3>
    <p>第一套是经典蓝白条纹水手服，搭配草帽和沙滩凉鞋，展现少女的青春活力。在海浪轻拍的沙滩上，萌白酱赤脚漫步，笑容如阳光般灿烂。</p>
    <h3>2. 梦幻白纱裙</h3>
    <p>第二套换上了飘逸的白色纱裙，微风吹拂下裙摆飞舞，搭配贝壳发饰和淡雅妆容，宛如海之精灵降临人间。夕阳时分的光线为这套造型增添了梦幻氛围。</p>
    <h3>3. 性感比基尼外套</h3>
    <p>第三套则是大胆的比基尼搭配半透明防晒外套，健康的小麦色肌肤在阳光下闪耀，展现成熟女性的自信魅力。这套造型在社交平台发布后获得粉丝热烈反响。</p>
    <p>拍摄期间，萌白酱还与现场工作人员进行了有趣的沙滩排球互动，花絮视频将于本周在B站频道独家播出，敬请期待！</p>
    <p>感谢所有支持萌白酱的粉丝朋友们，你们的每一次点赞和转发都是萌白酱继续创作的动力！未来还会有更多精彩的cosplay作品与大家见面。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Beautiful%20anime%20style%20girl%20in%20elegant%20white%20summer%20dress%20on%20tropical%20beach%20at%20sunset%2C%20soft%20golden%20light%2C%20dreamy%20atmosphere%2C%20flowing%20fabric%2C%20gentle%20waves%2C%20warm%20pastel%20tones%2C%20artistic%20photography%2C%20cinematic%20composition%2C%20kawaii%20vibe&width=1200&height=675&seq=mengbai-article-1&orientation=landscape',
    author: '萌白酱',
    publishDate: '2026-08-05',
    views: 38520,
    likes: 12850,
    tags: ['cosplay', '夏日', '海边', '写真', '限定'],
    isFeatured: true,
  },
  {
    id: 'article-2',
    title: '【B站百万粉纪念】萌白酱特别直播回放与粉丝感言',
    slug: 'bilibili-million-fans',
    categorySlug: 'videos',
    categoryName: '最新视频',
    excerpt: '庆祝B站粉丝突破100万！萌白酱特别感谢直播全程回顾，包含粉丝问答、惊喜抽奖和未公开的幕后故事。',
    content: `<p>2026年7月28日，是一个值得铭记的日子——萌白酱B站频道正式突破100万粉丝！为感谢每一位粉丝的支持与陪伴，萌白酱在当晚举办了一场特别纪念直播。</p>
    <h3>直播亮点回顾</h3>
    <p>直播从晚上8点开始，持续了整整3个小时。萌白酱首先回顾了从零到一百万的创作历程，分享了早期视频拍摄的幕后趣事和那些不为人知的努力时光。</p>
    <p>"还记得第一个视频发布时，只有几十个播放量。但我看到了每一条评论，每一位支持我的朋友，是你们给了我继续创作的勇气。"萌白酱在直播中动情地说道。</p>
    <h3>粉丝问答环节</h3>
    <p>直播中萌白酱回答了粉丝们最关心的20个问题，包括日常生活的趣事、未来的创作计划、以及个人兴趣爱好等。最让人惊喜的是，萌白酱透露正在筹备个人原创歌曲，预计年底发布！</p>
    <h3>惊喜抽奖</h3>
    <p>直播共进行了五轮抽奖，送出了限定手办、签名写真集、定制周边大礼包等丰厚奖品。恭喜所有中奖的幸运粉丝！</p>
    <h3>未来展望</h3>
    <p>萌白酱表示，100万只是新的起点。接下来会推出更多高质量的视频内容，包括与多位知名UP主的联动企划、全新系列的cosplay写真，以及大家期待已久的原创音乐作品。</p>
    <p>再次感谢每一位支持萌白酱的朋友！让我们携手走向更精彩的未来！</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Colorful%20celebration%20party%20scene%20with%20balloons%20and%20confetti%2C%20festive%20atmosphere%2C%20warm%20pink%20and%20gold%20decorations%2C%20streaming%20setup%20with%20professional%20equipment%2C%20excited%20vibe%2C%20modern%20content%20creator%20studio%2C%20cinematic%20lighting%2C%20high%20quality%20photography&width=1200&height=675&seq=mengbai-article-2&orientation=landscape',
    author: '萌白酱',
    publishDate: '2026-07-29',
    views: 125800,
    likes: 35600,
    tags: ['B站', '百万粉丝', '直播', '纪念', '感谢'],
    isFeatured: true,
  },
  {
    id: 'article-3',
    title: '萌白酱×原神联动cosplay——雷电将军造型全解析',
    slug: 'genshin-raiden-cosplay',
    categorySlug: 'cosplay',
    categoryName: 'Cosplay写真',
    excerpt: '萌白酱最新原神雷电将军cosplay作品深度解析，从服装道具到妆容造型，全方位还原游戏角色魅力。',
    content: `<p>经过两个月的精心准备，萌白酱终于完成了《原神》雷电将军的cosplay作品。这套作品从服装定制到道具制作，每一个细节都力求完美还原。</p>
    <h3>服装设计</h3>
    <p>雷电将军的服装以其华丽的和风设计著称。萌白酱特别邀请了资深cosplay服装设计师，采用日本进口和风面料，手工绣制了服饰上的雷纹图案。整套服装制作耗时超过40天。</p>
    <h3>道具制作</h3>
    <p>雷电将军标志性的「梦想一心」太刀，由专业道具师使用EVA材料和树脂精心制作。刀身采用渐变喷漆工艺，在不同光线下呈现紫色到金色的流动效果，还原度极高。</p>
    <h3>妆容造型</h3>
    <p>为了完美呈现雷电将军冷艳高贵的气质，萌白酱在妆容上做了大量研究。紫色系眼妆搭配精致眉形，加上特制的彩色隐形眼镜，整体效果惊艳。</p>
    <h3>拍摄幕后</h3>
    <p>本次拍摄选择在杭州一处日式庭院进行，古朴的建筑风格与原神稻妻城的设计理念不谋而合。拍摄团队还包括了专业的灯光师和后期修图师，确保最终成片达到最高水准。</p>
    <p>这组作品在社交平台发布后，不到24小时就获得了超过50万的点赞量，被多家游戏媒体和cosplay社区转发推荐。感谢大家对萌白酱的支持！</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Elegant%20Japanese%20style%20warrior%20character%20in%20purple%20and%20gold%20kimono%20costume%2C%20traditional%20Japanese%20garden%20background%20with%20cherry%20blossoms%2C%20dramatic%20lighting%2C%20cinematic%20photography%2C%20mystical%20atmosphere%2C%20high%20detail%20costume%20design%2C%20professional%20cosplay%20photography&width=1200&height=675&seq=mengbai-article-3&orientation=landscape',
    author: '萌白酱',
    publishDate: '2026-07-20',
    views: 89200,
    likes: 28600,
    tags: ['cosplay', '原神', '雷电将军', '游戏', '和风'],
    isFeatured: true,
  },
  {
    id: 'article-4',
    title: '萌白酱2026秋季新品周边预告——限定手办&主题服饰',
    slug: '2026-autumn-merch-preview',
    categorySlug: 'merch',
    categoryName: '周边产品',
    excerpt: '萌白酱2026秋季周边新品大公开！限量版Q版手办、原创设计主题T恤、精美亚克力立牌等新品抢先看。',
    content: `<p>秋季新品周边来啦！萌白酱携手知名周边制造商，为粉丝们带来了一系列精心设计的官方正版周边产品。</p>
    <h3>限定Q版手办</h3>
    <p>本次推出的限定Q版手办以萌白酱最经典的兔耳造型为原型，采用PVC+ABS材质，高约15cm。手办包含可替换表情零件和配件，限量发售3000体，每体附带独立编号收藏证书。</p>
    <h3>原创主题T恤</h3>
    <p>三款不同设计的主题T恤，分别以萌白酱的代表性元素——小兔子、星星和樱花为主题。采用320g纯棉面料，舒适透气，男女皆可穿着。尺码覆盖S-3XL。</p>
    <h3>精美亚克力立牌</h3>
    <p>五种造型的亚克力立牌套装，收录了萌白酱2026年人气最高的五套造型。高透明度亚克力材质，背面印制萌白酱亲笔签名，适合桌面装饰和收藏。</p>
    <h3>限定徽章套装</h3>
    <p>10枚入的主题徽章盲盒套装，包含2枚隐藏款。采用珐琅工艺制作，背面为安全别针设计，可佩戴于背包、衣物等。</p>
    <p>所有新品将于9月1日正式开启预售，敬请关注萌白酱官方商城和B站会员购渠道。提前收藏加购，不要错过限量发售哦！</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Cute%20kawaii%20anime%20style%20merchandise%20collection%20display%2C%20figurines%20and%20t-shirts%20with%20bunny%20motif%2C%20pastel%20pink%20and%20cream%20color%20palette%2C%20organized%20product%20photography%2C%20soft%20lighting%2C%20clean%20white%20background%2C%20professional%20commercial%20photography%2C%20high%20detail&width=1200&height=675&seq=mengbai-article-4&orientation=landscape',
    author: '萌白酱',
    publishDate: '2026-08-01',
    views: 45200,
    likes: 15800,
    tags: ['周边', '手办', '限定', '秋季新品', 'T恤'],
    isFeatured: false,
  },
  {
    id: 'article-5',
    title: '萌白酱日常Vlog——一天的工作与生活记录',
    slug: 'daily-vlog-2026-summer',
    categorySlug: 'videos',
    categoryName: '最新视频',
    excerpt: '跟萌白酱一起度过普通又充实的一天！从清晨瑜伽到深夜剪辑，带你走进萌白酱的真实日常。',
    content: `<p>很多粉丝好奇萌白酱的日常生活是怎样的？这次的Vlog就带大家一起体验萌白酱真实的一天！</p>
    <h3>7:00 清晨瑜伽</h3>
    <p>每天清晨，萌白酱都会花30分钟做瑜伽和拉伸。保持良好的身体状态是高质量cosplay拍摄的基础。今天的晨间音乐是最近很喜欢的Lo-fi hip-hop歌单。</p>
    <h3>9:00 创意会议</h3>
    <p>上午与团队进行周度创意会议，讨论了接下来三个月的视频选题和cosplay拍摄计划。大家的想法碰撞出了不少有趣的火花，下一期的联动企划值得期待！</p>
    <h3>12:00 午餐时间</h3>
    <p>今天的午餐是自制牛油果鸡肉沙拉和一杯燕麦拿铁。萌白酱分享了自己的饮食管理心得：作为内容创作者，保持健康的饮食习惯对维持精力很重要。</p>
    <h3>14:00 拍摄准备</h3>
    <p>下午开始为周末的cosplay拍摄做准备工作。检查服装和道具的状态，试妆调整细节。每一个拍摄前的准备工作都不能马虎。</p>
    <h3>18:00 舞蹈练习</h3>
    <p>傍晚是舞蹈练习时间。萌白酱最近在学习一支新的宅舞，为下个月的漫展表演做准备。练习虽然辛苦但很快乐！</p>
    <h3>21:00 视频剪辑</h3>
    <p>晚上是视频剪辑时间。萌白酱亲自参与了大部分视频的后期剪辑工作，希望每一个作品都能呈现出最好的效果。今天剪辑到凌晨一点才收工。</p>
    <p>虽然忙碌，但能做自己喜欢的事情并得到大家的喜爱，每一天都很幸福！</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Cozy%20minimalist%20home%20studio%20with%20warm%20morning%20light%2C%20cute%20pink%20decorations%2C%20yoga%20mat%20on%20wooden%20floor%2C%20creative%20workspace%20with%20laptop%20and%20plants%2C%20soft%20pastel%20color%20scheme%2C%20lifestyle%20photography%2C%20clean%20aesthetic%2C%20dreamy%20atmosphere&width=1200&height=675&seq=mengbai-article-5&orientation=landscape',
    author: '萌白酱',
    publishDate: '2026-07-25',
    views: 67100,
    likes: 21300,
    tags: ['Vlog', '日常', '生活', '幕后', '瑜伽'],
    isFeatured: false,
  },
  {
    id: 'article-6',
    title: '萌白酱粉丝社群两周年庆典活动回顾',
    slug: 'fan-community-2nd-anniversary',
    categorySlug: 'community',
    categoryName: '粉丝社区',
    excerpt: '萌白酱官方粉丝社群成立两周年！线上线下联动庆典精彩回顾，包含粉丝才艺展示、互动游戏和惊喜环节。',
    content: `<p>时光飞逝，萌白酱官方粉丝社群已经陪伴大家走过了两个春秋！为庆祝这个特别的日子，我们举办了一场线上线下联动的庆典活动。</p>
    <h3>线上庆典</h3>
    <p>线上庆典在B站直播间举行，持续4个小时。活动内容包括：</p>
    <ul>
      <li>社区两年来的精彩瞬间回顾视频</li>
      <li>粉丝才艺展示环节——收到了超过200份粉丝投稿</li>
      <li>萌白酱与粉丝的实时互动问答</li>
      <li>周年限定周边首发抽奖</li>
    </ul>
    <h3>线下聚会</h3>
    <p>同日在上海举办了线下粉丝聚会，50位幸运粉丝来到现场。大家一起切蛋糕、玩游戏、合影留念，现场气氛温馨而热烈。</p>
    <h3>粉丝感言</h3>
    <p>"加入萌白酱社群是我今年最开心的事，认识了很多志同道合的朋友，感谢萌白酱创造了这么温暖的大家庭！" —— 粉丝代表小兔子</p>
    <p>"两年来见证了萌白酱的成长和努力，每一份作品都倾注了心血。我们会一直支持萌白酱！" —— 资深粉丝星空</p>
    <p>感谢每一位参与庆典的粉丝，萌白酱因为有你们而更加精彩！让我们共同期待三周年、五周年、十周年的到来！</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Fan%20celebration%20party%20with%20colorful%20balloons%20and%20banners%2C%20warm%20festive%20atmosphere%2C%20people%20gathering%20and%20celebrating%2C%20pink%20and%20gold%20decorations%2C%20cozy%20indoor%20venue%2C%20happy%20vibe%2C%20professional%20event%20photography%2C%20candid%20moments&width=1200&height=675&seq=mengbai-article-6&orientation=landscape',
    author: '萌白酱',
    publishDate: '2026-07-15',
    views: 32100,
    likes: 12400,
    tags: ['粉丝社群', '周年', '庆典', '线下聚会', '互动'],
    isFeatured: false,
  },
  {
    id: 'article-7',
    title: '萌白酱×崩坏星穹铁道——花火cosplay惊艳登场',
    slug: 'honkai-star-rail-sparkle-cosplay',
    categorySlug: 'cosplay',
    categoryName: 'Cosplay写真',
    excerpt: '萌白酱最新崩坏星穹铁道花火cosplay作品，多彩绚丽的服装造型与活泼俏皮的演绎，还原度满分！',
    content: `<p>继雷电将军之后，萌白酱又带来了《崩坏：星穹铁道》中人气角色——花火的cosplay作品！</p>
    <h3>角色理解</h3>
    <p>花火是一个充满活力、古灵精怪的少女角色。为了准确把握角色的神韵，萌白酱反复观看了游戏中的花火剧情动画，揣摩角色的表情和动作细节。</p>
    <h3>服装还原</h3>
    <p>花火的服装以红白配色为主，装饰有大量缎带和花朵元素。服装团队参考了官方设定集和游戏内模型，对每一处褶皱和花纹都进行了精确还原。裙子上的渐变印花采用数码直喷工艺，色彩鲜艳持久。</p>
    <h3>场景选择</h3>
    <p>拍摄地点选在了上海一处充满未来感的艺术空间，霓虹灯光与花火活泼的性格相得益彰。摄影师运用了多种创意拍摄手法，包括慢门光绘和多角度动态抓拍。</p>
    <h3>粉丝反响</h3>
    <p>作品发布后迅速登上cosplay社区热门榜单，不少粉丝表示"这就是从游戏里走出来的花火！"崩坏星穹铁道官方账号也转发了这组作品，获得了官方认可！</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Colorful%20vibrant%20cosplay%20portrait%20with%20red%20and%20white%20costume%2C%20neon%20lights%20background%2C%20playful%20dynamic%20pose%2C%20futuristic%20urban%20setting%2C%20professional%20cosplay%20photography%2C%20dramatic%20lighting%2C%20anime%20style%20aesthetic%2C%20high%20energy%20atmosphere&width=1200&height=675&seq=mengbai-article-7&orientation=landscape',
    author: '萌白酱',
    publishDate: '2026-07-10',
    views: 76300,
    likes: 24200,
    tags: ['cosplay', '崩坏星穹铁道', '花火', '游戏', '霓虹'],
    isFeatured: false,
  },
  {
    id: 'article-8',
    title: '萌白酱粉丝见面会——2026年漫展行程公布',
    slug: '2026-comic-con-schedule',
    categorySlug: 'news',
    categoryName: '动态资讯',
    excerpt: '萌白酱2026年下半年漫展出席行程正式公布！包含上海、广州、成都等多站，附详细时间地点和参与方式。',
    content: `<p>期待已久的漫展季节来啦！萌白酱正式公布2026年下半年线下活动行程安排。想和萌白酱面对面交流的粉丝们千万不要错过！</p>
    <h3>上海·ChinaJoy 2026</h3>
    <p>日期：2026年8月15日-17日<br>地点：上海新国际博览中心<br>萌白酱将在B站展台进行签售和粉丝互动，每天下午2:00-4:00。</p>
    <h3>广州·萤火虫动漫嘉年华</h3>
    <p>日期：2026年9月20日-22日<br>地点：广州琶洲国际会展中心<br>萌白酱将作为特邀嘉宾出席舞台活动和签售会。</p>
    <h3>成都·CD26同人展</h3>
    <p>日期：2026年10月5日-6日<br>地点：成都世纪城新国际会展中心<br>萌白酱将在独立展位进行周边签售和现场cosplay展示。</p>
    <h3>杭州·第五届国风动漫节</h3>
    <p>日期：2026年11月15日-16日<br>地点：杭州国际博览中心<br>萌白酱将带来特别企划的古风cosplay表演。</p>
    <p>所有活动现场均可购买萌白酱官方周边产品。部分场次提供限定特典，仅限现场购买。具体购票信息请关注各漫展官方渠道。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Large%20comic%20convention%20exhibition%20hall%20with%20colorful%20booths%20and%20displays%2C%20crowds%20of%20fans%2C%20cosplay%20performers%2C%20vibrant%20atmosphere%2C%20professional%20event%20photography%2C%20warm%20lighting%2C%20exciting%20energy%2C%20wide%20angle%20shot&width=1200&height=675&seq=mengbai-article-8&orientation=landscape',
    author: '萌白酱',
    publishDate: '2026-07-05',
    views: 54800,
    likes: 19800,
    tags: ['漫展', '线下活动', '签售', '行程', '粉丝见面'],
    isFeatured: false,
  },
  {
    id: 'article-9',
    title: '萌白酱新曲预告——原创单曲即将发布',
    slug: 'original-song-preview',
    categorySlug: 'news',
    categoryName: '动态资讯',
    excerpt: '萌白酱首支个人原创单曲制作中！知名音乐人操刀制作，融合J-Pop与电子元素的治愈系歌曲，敬请期待。',
    content: `<p>重磅消息！萌白酱正在筹备个人首支原创单曲，这是萌白酱音乐道路上的重要里程碑！</p>
    <h3>制作团队</h3>
    <p>本次单曲邀请了日本知名音乐制作人山田太郎（化名）担任制作人，编曲由曾为多位知名虚拟UP主打造热单的作曲家担当。歌词由萌白酱亲自参与创作，融入了自己一路走来的感悟和对粉丝的感谢。</p>
    <h3>音乐风格</h3>
    <p>歌曲风格定位为J-Pop融合电子元素的治愈系歌曲。轻快的节奏配合温暖的歌词，希望给听众带来积极向上的能量。副歌部分特别设计了易于跟唱的旋律，期待在演唱会现场与粉丝们一起合唱！</p>
    <h3>发布计划</h3>
    <p>目前歌曲已经完成录音阶段，正在进行后期混音和母带处理。MV的拍摄也在同步筹备中。预计2026年12月在各大音乐平台同步上线，B站将提前一周发布MV预告片。</p>
    <h3>粉丝福利</h3>
    <p>单曲发布前，萌白酱将在粉丝社群中抽取100位幸运粉丝，赠送签名版限定实体CD。CD封面由萌白酱亲自设计，值得收藏！</p>
    <p>音乐是萌白酱一直以来的梦想，感谢大家的支持和等待。这首歌，送给每一位陪伴萌白酱成长的朋友！</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Professional%20music%20recording%20studio%20with%20microphone%20and%20headphones%2C%20warm%20pink%20ambient%20lighting%2C%20musical%20instruments%20in%20background%2C%20creative%20atmosphere%2C%20modern%20studio%20equipment%2C%20cozy%20vibe%2C%20professional%20photography%2C%20clean%20composition&width=1200&height=675&seq=mengbai-article-9&orientation=landscape',
    author: '萌白酱',
    publishDate: '2026-06-28',
    views: 98200,
    likes: 32000,
    tags: ['原创歌曲', '音乐', '新曲', '预告', 'J-Pop'],
    isFeatured: true,
  },
];

export const getArticleBySlug = (slug: string): Article | undefined => {
  return articles.find((article) => article.slug === slug);
};

export const getArticlesByCategory = (categorySlug: string): Article[] => {
  return articles.filter((article) => article.categorySlug === categorySlug);
};

export const getFeaturedArticles = (): Article[] => {
  return articles.filter((article) => article.isFeatured);
};

export const getLatestArticles = (limit: number = 6): Article[] => {
  return [...articles].sort((a, b) => new Date(b.publishDate).getTime() - new Date(a.publishDate).getTime()).slice(0, limit);
};

export const getAllArticles = (): Article[] => articles;